module.exports = __webpack_public_path__ + "media/spiral-1600.47d7b8c1.mp4";